import { useCallback } from 'react';
import * as THREE from 'three';
import { useThree } from '@react-three/fiber';
import { Html } from '@react-three/drei';
import type { Number3 } from '../../types';
import { lengthToLocaleString } from '../Util';
import { useAbyssViewerContext } from '../AbyssViewerContext';

const zIndexRange = [100, 0];
const noPointerStyle: React.CSSProperties = { pointerEvents: 'none' };
const displayNameDivStyle: React.CSSProperties = {
  backgroundColor: 'white',
  padding: '4px 8px',
  borderRadius: '4px',
};
const displayNameSpanStyle: React.CSSProperties = { color: 'black', userSelect: 'all' };
const displayDistanceSpanStyle: React.CSSProperties = { color: 'black', fontSize: 'smaller' };

// TODO: Consider to remove this logic from viewer
const imageDisplayName = (name: string) => (name.includes('/') ? name.split('/').pop() : name);

export type ImageBillboardProps = {
  position: Number3;
  imagePosition?: Number3;
  name: string;
};

export const ImageBillboard = ({ position, imagePosition, name }: ImageBillboardProps) => {
  const camera = useThree((state) => state.camera);
  const { unitSystem } = useAbyssViewerContext();
  const displayDistanceFromCamera = useCallback(
    (imagePosition: Number3) => {
      if (!unitSystem) return '';
      const positionVec = new THREE.Vector3(...imagePosition);
      const distance = camera.position.distanceTo(positionVec);
      return lengthToLocaleString(distance, unitSystem);
    },
    [unitSystem, camera]
  );

  return (
    <>
      <Html as="div" center zIndexRange={zIndexRange} style={noPointerStyle} position={position}>
        <div style={displayNameDivStyle}>
          <span style={displayNameSpanStyle}>{imageDisplayName(name)}</span>
          <br />
          <span style={displayDistanceSpanStyle}>
            {displayDistanceFromCamera(imagePosition ?? position)}
          </span>
        </div>
      </Html>
    </>
  );
};
